import { useContext } from "react";
import { useRecoilState } from "recoil";

import { PageHeaderContext, useReportId } from "@ryde/redux";
import { rideFilterSearchAtom } from "@ryde/shared";

import { useResolveSearchFilteredRowsReport } from "./parts";

export const useReportFilterSearch = () => {
  const { reportId } = useReportId();
  const [tableSearch, setTableSearch] = useRecoilState(
    rideFilterSearchAtom(reportId),
  );
  const { onSearchApply } = useContext(PageHeaderContext);

  const { isSearchWithoutError } = useResolveSearchFilteredRowsReport();

  const isError = !isSearchWithoutError;

  return {
    searchValue: tableSearch,
    isError,
    onChange: setTableSearch,
    onSearchApply,
  };
};
